<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter">
<div class="part">
<p class="noindent_paraf"><span epub:type="pagebreak" id="page_x" title="x">Journeys have value in themselves and are not just a device for saving time.</span></p>
<p class="rightr">E. B. White, “The Railroad,” <i>Essays of E. B. White</i></p>
<p class="common"><img alt="" src="images/common.jpg" style="width: 15%"/></p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Frontmatter05.vue?375df852